module.exports = __webpack_public_path__ + "files/42896065011ea8362c3cc8c2cb192210.png";